import React from 'react'
import MusicPlayer from './music-player'

const MusicPlayerWrapper = () => {
    return (
        <div className="music-player-wrapper">
            <MusicPlayer key={1} componentName="musicSourceOne" />
            <MusicPlayer key={2} componentName="musicSourceTwo" />
        </div>
    )
}

export default MusicPlayerWrapper
